import React, { useState, useEffect } from "react"

import { Section, Block, Note } from "../../Sandbox"
import {
  ReleasedAt,
  HeaderPoints,
} from "./"
import RoundProgress from "./RoundProgress"
import EmbedHostAndColorModeSwitcher from "../../Sandbox/EmbedHostAndColorModeSwitcher"

const RoundProgressSandbox: React.FC = () => {
  const [ roundProgressQuestionNumber, setRoundProgressQuestionNumber ] = useState(1)
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRoundProgressQuestionNumber((prev) => {
        const newNum = prev + 1
        return newNum > 100 ? 1 : newNum
      })
    }, 100)

    return () => { // cleanup
      window.clearInterval(interval)
    }
  })
  return (
    <Section title="RoundProgress">
      <Note>Changing / With total / Without total / empty / full</Note>
      <Block framed>
        <div className="neo__quiz--palette1">
          <RoundProgress currentQuestionNumber={roundProgressQuestionNumber} numTotalQuestions={100} />
          <RoundProgress currentQuestionNumber={7} numTotalQuestions={10} />
          <RoundProgress currentQuestionNumber={12} numTotalQuestions={undefined} />
          <RoundProgress currentQuestionNumber={1} numTotalQuestions={10} />
          <RoundProgress currentQuestionNumber={10} numTotalQuestions={10} />
        </div>
      </Block>
    </Section>
  )
}

const QuizUiSandbox: React.FC = () => {
  return <EmbedHostAndColorModeSwitcher>
    <RoundProgressSandbox />
    <Section title="Header / Footer">
      <Note>ReleasedAt</Note>
      <Block framed>
        <ReleasedAt date="1.5.1983" />
      </Block>
      <Note>HeaderPoints (with total, without total)</Note>
      <Block framed>
        <HeaderPoints current={0} total={10000} />
      </Block>
      <Block framed>
        <HeaderPoints current={5} />
      </Block>
    </Section>
  </EmbedHostAndColorModeSwitcher>
}

export default QuizUiSandbox
